import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import Header from "modules/SubComponents/Header";
import SubHeader from "modules/SubComponents/SubHeader";
import subscribersIcon from "assets/icons/subscribers.svg";
import incomeIcon from "assets/icons/income.svg";
import viewsIcon from "assets/icons/views.svg";
import {
  allViewsOnSystem,
  getNumberOfAnimationOnSystem,
  getNumberOfAnimationViewsOnSystem,
  getNumberOfKnowItOnSystem,
  getNumberOfKnowItViewsOnSystem,
  getNumberOfMoviesOnSystem,
  getNumberOfMovieViewsOnSystem,
  getNumberOfSeriesOnSystem,
  getNumberOfSeriesViewsOnSystem,
  getSystemCategoryByPercentage,
  getSystemHourlyViews,
  getSystemTrendingShows,
  getSystemWeaklyViews,
  getAllGenresOnSystem,
  getAllCategoriesByGenreId,
  getTotalIncome,
} from "Network";
import { toastError } from "helpers/toasters";
import BarChart from "./BarChart";
import DoughnutChart from "./DoughnutChart";
import magnifyingGlass from "assets/icons/search.svg";

import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import LineChart from "./LineChart";
import { baseUrl } from "services";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { roundsToTheNearestTwoDigits } from "helpers/helpfulFunctions";
import { DatePicker, Spin, Table, Button, Input, Select } from "antd";
import CategoryViews from "./CategoryViews";
import { useSelector } from "react-redux";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  ChartDataLabels
);

export const UserContext = React.createContext();

const { RangePicker } = DatePicker;

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [totalSubscribers, setTotalSubscribers] = useState(null);
  const [totalValueOfIncome, setTotalValueOfIncome] = useState(null);
  const [totalNumOfViews, setTotalNumOfViews] = useState(null);
  const [weaklyViewsDaysCount, setWeaklyViewsDaysCount] = useState("7");
  const [barDataSet, setBarDataset] = useState([]);
  const [barLables, setBarLables] = useState([]);
  const [categoryDataSet, setCategoryDataSet] = useState([]);
  const [categoryColors, setCategoryColors] = useState([]);
  const [categoryLables, setCategoryLables] = useState([]);
  const [categoryPercentageLables, setCategoryPercentageLables] = useState([]);
  const [categoryPercentage, setCategoryPercentage] = useState([]);
  const [hourlyViewsDaysCount, setHourlyViewsDaysCount] = useState("7");
  const [lineDataSet, setLineDataSet] = useState([]);
  const [lineLables, setLineLables] = useState([]);
  const [trendingViewsDaysCount, setTrendingShowsDaysCount] = useState("7");
  const [trendingShowsData, setTrendingShowsData] = useState([]);
  const [seriesNumber, setSeriesNumber] = useState(null);
  const [seriesViews, setSeriesViews] = useState(null);
  const [moviesNumber, setMoviesNumber] = useState(null);
  const [movieViews, setMovieViews] = useState(null);
  const [animationNumber, setAnimationNumber] = useState(null);
  const [animationViews, setAnimationViews] = useState(null);
  const [knowItNumber, setKnowItNumber] = useState(null);
  const [knowItViews, setKnowItViews] = useState(null);
  // const [storeNumber, setStoreNumber] = useState(null);
  // const [storeViews, setStoreViews] = useState(null);
  const [dates, setDates] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);
  const [lineChartLoading, setLineChartLoading] = useState(false);

  const [genres, setGenres] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [disableCategory, setDisableCategory] = useState(true);
  const [resetButton, setResetButton] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [movieName, setMovieName] = useState("");

  const {
    authorization: { isCeo },
  } = useSelector((state) => state?.auth);

  useEffect(() => {
    getAllGenresOnSystem(
      (success) => {
        const genresData = success?.data?.map((item) => {
          return { name: item.name, id: item.id };
        });
        setGenres(genresData);
      },
      (error) => {}
    );
  }, []);

  useEffect(() => {
    if (selectedGenre) {
      setResetButton(true);
      setDisableCategory(true);
      getAllCategoriesByGenreId(
        { genreId: selectedGenre },
        (success) => {
          setDisableCategory(false);
          setCategories(success.data);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }, [selectedGenre]);

  useEffect(() => {
    if (isCeo) {
      getTotalIncome(
        (success) => {
          if (success?.isSuccess) {
            setTotalValueOfIncome(
              roundsToTheNearestTwoDigits(success.data?.totalValueOfIncome)
            );
          }
        },
        (fail) => {
          if (fail?.data) {
            toastError(fail.data.err_msg);
          } else {
            toastError();
          }
        },
        dates
      );
    }

    allViewsOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setTotalSubscribers(
            roundsToTheNearestTwoDigits(success.data?.totalSubscriber)
          );
          setTotalNumOfViews(
            roundsToTheNearestTwoDigits(success.data?.allViews)
          );
        }
      },
      (fail) => {
        if (fail?.data) {
          toastError(fail.data.err_msg);
        } else {
          toastError();
        }
      },
      dates
    );

    // Numbers
    getNumberOfSeriesOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setSeriesNumber(
            roundsToTheNearestTwoDigits(success?.data?.numberOfSeries)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfMoviesOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setMoviesNumber(
            roundsToTheNearestTwoDigits(success?.data?.numberOfMovies)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfAnimationOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setAnimationNumber(
            roundsToTheNearestTwoDigits(success?.data?.numberOfSeries)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfKnowItOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setKnowItNumber(
            roundsToTheNearestTwoDigits(success?.data?.numberOfSeries)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );

    // Views
    getNumberOfSeriesViewsOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setSeriesViews(
            roundsToTheNearestTwoDigits(success?.data?.allSeriesViews)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfMovieViewsOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setMovieViews(
            roundsToTheNearestTwoDigits(success?.data?.allMoviesViews)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfAnimationViewsOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setAnimationViews(
            roundsToTheNearestTwoDigits(success?.data?.allSeriesViews)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );
    getNumberOfKnowItViewsOnSystem(
      (success) => {
        if (success?.isSuccess) {
          setKnowItViews(
            roundsToTheNearestTwoDigits(success?.data?.allSeriesViews)
          );
        }
      },
      (fail) => {
        toastError(fail?.data?.err_msg);
      },
      dates
    );

    // Category By Percent
    getSystemCategoryByPercentage(
      (success) => {
        if (success?.isSuccess) {
          setCategoryDataSet(success?.data);
          setCategoryColors(success.data?.map((item) => item?.color));
          setCategoryLables(success.data?.map((item) => item?.name));
          setCategoryPercentage(
            success.data?.map((item) => +item?.percentage.split("%")[0])
          );
          setCategoryPercentageLables(
            success.data?.map((item) => item?.percentage)
          );
        }
      },
      (fail) => {
        console.log("🚀 ~ fail:", fail);
        if (fail?.data) {
          toastError(fail.data.err_msg);
        } else {
          toastError();
        }
      },
      dates
    );
  }, [dates]);

  useEffect(() => {
    setChartLoading(true);
    getSystemWeaklyViews(
      { weaklyViewsDaysCount, dates },
      (success) => {
        if (success?.isSuccess) {
          setBarDataset(success?.data?.map((item) => item.views));
          setBarLables(success?.data?.map((item) => item.day));
        }
        setChartLoading(false);
      },
      (fail) => {
        setChartLoading(false);
        if (fail?.data) {
          toastError(fail.data.err_msg);
        } else {
          toastError();
        }
      }
    );
  }, [weaklyViewsDaysCount, dates]);

  useEffect(() => {
    setLineChartLoading(true);
    if (hourlyViewsDaysCount > 0) {
      getSystemHourlyViews(
        { hourlyViewsDaysCount, dates },
        (success) => {
          setLineChartLoading(false);
          if (success?.isSuccess) {
            setLineDataSet(success.data?.map((item, index) => item?.views));
            setLineLables(success.data?.map((item, index) => item?.hour));
          }
        },
        (fail) => {
          setLineChartLoading(false);
          if (fail?.data) {
            toastError(fail.data.err_msg);
          } else {
            toastError();
          }
        }
      );
    } else {
      toastError("please enter a valid number");
    }
  }, [hourlyViewsDaysCount, dates]);

  useEffect(() => {
    setLoading(true);
    getSystemTrendingShows(
      {
        trendingViewsDaysCount,
        dates,
        selectedGenre,
        selectedCategory,
        movieName,
      },
      (success) => {
        if (success?.isSuccess) {
          setTrendingShowsData(success.data);
          setLoading(false);
        }
      },
      (fail) => {
        if (fail?.data) {
          toastError(fail.data.err_msg);
          setLoading(false);
        } else {
          toastError();
        }
      }
    );
  }, [
    trendingViewsDaysCount,
    dates,
    selectedGenre,
    selectedCategory,
    movieName,
  ]);

  useEffect(() => {
    let searchHandler;
    if (searchValue) {
      searchHandler = setTimeout(() => {
        setMovieName(searchValue);
      }, 1000);
    } else {
      setMovieName("");
    }

    return () => clearTimeout(searchHandler);
  }, [searchValue]);

  const barData = {
    labels: barLables,
    datasets: [
      {
        data: barDataSet,
        backgroundColor: [
          "#006AF5",
          "#37557B",
          "#356AB3",
          "#477BBF",
          "#84A0C5",
          "#B6D4FC",
          "#4D97F9",
        ],
        barThickness: 40,
        borderColor: "none",
        borderWidth: 0,
        borderRadius: 2,
        color: ["#FFFFFF"],
      },
    ],
  };

  const lineData = {
    labels: lineLables,
    datasets: [
      {
        label: "Hourly Views",
        data: lineDataSet,
        backgroundColor: "#2A85FF",
        borderColor: "#356AB3",
        borderWidth: 4,
        borderRadius: 2,
        borderCapStyle: "round",
        tension: ".4",
        fill: false,
        pointStyle: "circle",
        pointBorderColor: "#2A85FF",
        pointBorderWidth: "7",
        drawActiveElementsOnTop: "true",
        showLine: true,
      },
    ],
  };

  const categoryData = {
    labels: categoryLables,
    datasets: [
      {
        label: categoryPercentageLables,
        data: categoryPercentage,
        backgroundColor: categoryColors,
        cutout: "55%",
        borderJoinStyle: "miter",
        circumference: 360,
        rotation: 180,
        borderRadius: 0,
        spacing: 2,
        weight: 20,
      },
    ],
  };

  const getBarsChartOptions = (barTitle) => {
    const options = {
      responsive: true,
      scales: {
        yAxes: {
          grid: { display: false, color: "red" },
          title: {
            display: false,
            text: barTitle,
            color: "#12819c",
            font: {
              size: 16,
            },
          },
        },
        xAxes: {
          grid: { display: false, color: "red" },
          title: {
            display: false,
            text: barTitle,
            color: "#12819c",
            font: {
              size: 16,
            },
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          xAlign: "center",
          yAlign: "bottom",
        },
        datalabels: {
          color: "#37557b",
          backgroundColor: "#fff",
          borderRadius: 100,
          anchor: "middle",
          align: "middle",
          font: {
            weight: "bold",
            size: 14,
          },
          padding: 4, // Add padding to text
          align: "center",
          anchor: "center",
        },
      },
    };
    return options;
  };

  const getLineChartOptions = (barTitle) => {
    const options = {
      responsive: true,
      scales: {
        yAxes: {
          grid: { display: true, color: "#D0D2D4" },
          title: {
            display: false,
            text: barTitle,
            color: "#12819c",
            font: {
              size: 16,
            },
          },
        },
        xAxes: {
          grid: { display: true, color: "#D0D2D4" },
          title: {
            display: false,
            text: barTitle,
            color: "#12819c",
            font: {
              size: 16,
            },
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          xAlign: "left",
          yAlign: "top",
        },
        datalabels: {
          color: "#37557b",
          padding: 15,
          // backgroundColor: "#37557b",
          anchor: "end",
          align: "top",
          font: {
            weight: "bold",
            size: 14,
          },
          formatter: (value) => {
            return value ? value : ``;
          },
        },
      },
    };
    return options;
  };

  const getDoughnutChartOptions = (barTitle) => {
    const options = {
      responsive: true,
      plugins: {
        legend: {
          display: false,
          position: "bottom",
          style: { display: "block" },
        },
        datalabels: {
          color: "#FFFFFF",
          font: {
            size: 10,
          },
          opacity: 0.74,
          anchor: "center",
          align: "center",

          // formatter: (value) => {
          //   return `${+value.toFixed(2)}%`; // Format the value as a percentage with 2 decimal places
          //   // return `${value.toFixed(2)}%`; // Format the value as a percentage with 2 decimal places
          // },

          formatter: (value) => {
            return ``; // Format the value as a percentage with 2 decimal places
            // return `${value.toFixed(2)}%`; // Format the value as a percentage with 2 decimal places
          },
        },
        tooltip: {
          xAlign: "center",
          yAlign: "bottom",
        },
      },
    };
    return options;
  };

  const trendingShowsColumns = [
    {
      title: "",
      key: "videoImgPath",
      dataIndex: "videoImgPath",
      render: (image, record) => {
        return (
          <div className="cast-img">
            <figure className="cast-img-figure">
              <img
                className="cast-img-path"
                src={baseUrl + record?.videoImgPath}
                alt="Actor"
              />
            </figure>
          </div>
        );
      },
    },
    {
      title: "TITLE",
      key: "videoTitle",
      dataIndex: "videoTitle",
    },
    {
      title: "GENRE",
      key: "videoGenre",
      dataIndex: "videoGenre",
    },
    {
      title: "CATEGORY",
      key: "videoCategory",
      dataIndex: "videoCategory",
    },
    {
      title: "NO.OF VIEWS",
      key: "countOfViews",
      dataIndex: "countOfViews",
    },
    {
      title: "DURATION",
      key: "duration",
      dataIndex: "duration",
    },
    {
      title: "AVG. WATCHING DURATION",
      key: "averageWatchTime",
      dataIndex: "averageWatchTime",
    },
  ];

  let weaklyHandler;
  function getWeaklyViewsDaysCount(days) {
    console.log("🚀 ~ getWeaklyViewsDaysCount ~ days:", days);
    const reg = /[0-9]/;

    // Clear the previous timeout
    if (weaklyHandler) {
      clearTimeout(weaklyHandler);
    }

    if (reg.test(days)) {
      weaklyHandler = setTimeout(() => {
        if (days.startsWith(0) || +days <= 0) {
          toastError("Please enter the valid number");
        } else {
          setWeaklyViewsDaysCount(days);
        }
      }, 1000);
    } else {
      setWeaklyViewsDaysCount("7");
    }
  }

  let hourlyHandler;
  function getHourlyViewsDaysCount(days) {
    if (hourlyHandler) {
      clearTimeout(hourlyHandler);
    }
    if (days) {
      hourlyHandler = setTimeout(() => {
        if (days.startsWith(0) || +days <= 0) {
          toastError("Please enter the valid number");
        } else {
          setHourlyViewsDaysCount(days);
        }
      }, 1000);
    } else {
      setHourlyViewsDaysCount("7");
    }
  }

  let trendingShowsHandler;
  function getTrendingShowsDaysCount(days) {
    if (trendingShowsHandler) {
      clearTimeout(trendingShowsHandler);
    }
    if (days) {
      trendingShowsHandler = setTimeout(() => {
        if (days.startsWith(0) || +days <= 0) {
          toastError("Please enter the valid number");
        } else {
          setTrendingShowsDaysCount(days);
        }
      }, 1000);
    } else {
      setTrendingShowsDaysCount("7");
    }
  }

  const onDateChange = (range) => {
    if (!range || range.length === 0) {
      setDates([]);
    } else {
      const from = range?.[0]?.toISOString();
      const to = range?.[1]?.toISOString();
      setDates([from, to]);
    }
  };

  const handleResetSearch = () => {
    setSelectedGenre("");
    setSelectedCategory("");
    setSearchValue("");
    setDisableCategory(true);
    setResetButton(false);
  };

  const handleSearchOnChange = (e) => {
    setSearchValue(e.target.value);
  };

  const dropdownStyle = {
    border: " solid 1px #CEE2F6",
    borderRadius: "12px",
    boxShadow: "0px 8px 10px #0000001A ",
  };

  return (
    <section className="users ">
      <div className="users__all-contents ">
        <div className="users__content">
          <div className="dashboard ">
            <div className="dashboard__section ">
              <Header title="Dashboard" />
            </div>

            <RangePicker
              onChange={onDateChange}
              size="large"
              className="dashboard__date-range-picker"
            />

            <div className="dashboard__section ">
              <div className=" dashboard__overview wd-100 flex dir-col pad-x-25  ">
                <div className="dashboard__overview-header wd-100 ">
                  <SubHeader bgColor="#F58234" title="Overview" />
                </div>
                <div className="dashboard__overview-data wd-100 mrg-ys-20 flex dir-row justify-between items-center ">
                  <div className="dashboard__overview-card ">
                    <div className="dashboard__card-icon ">
                      <img src={subscribersIcon} alt="subscribers" />
                    </div>
                    <div className="dashboard__card-title ">
                      <span>Total Subscribers</span>
                    </div>
                    <div className="dashboard__card-quantity ">
                      <span>{totalSubscribers}</span>
                    </div>
                  </div>
                  {isCeo && (
                    <div
                      className="dashboard__overview-card "
                      // style={{ flex: "1", flexGrow: "2" }}
                    >
                      <div className="dashboard__card-icon ">
                        <img src={incomeIcon} alt="subscribers" />
                      </div>
                      <div className="dashboard__card-title ">
                        <span>Total value of income</span>
                      </div>
                      <div
                        className="dashboard__card-quantity "
                        title={totalValueOfIncome}
                      >
                        <span>{totalValueOfIncome} </span>
                      </div>
                    </div>
                  )}
                  <div className="dashboard__overview-card ">
                    <div className="dashboard__card-icon ">
                      <img src={viewsIcon} alt="subscribers" />
                    </div>
                    <div className="dashboard__card-title ">
                      <span>Total Num. of views</span>
                    </div>
                    <div className="dashboard__card-quantity ">
                      <span>{totalNumOfViews}</span>
                    </div>
                  </div>
                </div>
                {/* movie overview */}
                <div className="dashboard__card-container">
                  <CategoryViews
                    category={"Movies"}
                    number={moviesNumber}
                    views={movieViews}
                  />
                  {/* series overview */}
                  <CategoryViews
                    category={"Series"}
                    number={seriesNumber}
                    views={seriesViews}
                  />
                  {/* Animation overview */}
                  <CategoryViews
                    category={"Anime"}
                    number={animationNumber}
                    views={animationViews}
                  />
                  {/* Know it overview */}
                  <CategoryViews
                    category={"Know it"}
                    number={knowItNumber}
                    views={knowItViews}
                  />
                  {/* Store overview */}
                  {/* <CategoryViews
                    category={"Store"}
                    number={storeNumber}
                    views={storeViews}
                  /> */}
                </div>
              </div>
            </div>

            <div className="dashboard__section   ">
              <div className="dashboard__weakly-views wd-100 flex justify-between ">
                <div className="dashboard__bar-chart  ">
                  <div className="dashboard__view-subHeader  mrg-ys-5 mrg-ye-15 ">
                    <SubHeader
                      bgColor="#27A2D9"
                      title="Weakly views"
                      titleColor="#1A1D1F"
                      history="weakly-views"
                      handleHistory={getWeaklyViewsDaysCount}
                      method="days"
                    />
                  </div>
                  <div className="dashboard__view-chart ">
                    {chartLoading && (
                      <div className="dashboard__chart-loading ">
                        <Spin />
                      </div>
                    )}
                    {!chartLoading && (
                      <BarChart
                        data={barData}
                        options={getBarsChartOptions("Weakly Views")}
                      />
                    )}
                  </div>
                </div>
                {/*  */}
                {categoryDataSet.length ? (
                  <div
                    className="
                      dashboard__doughnut-chart flex dir-col items-center content-start pad-25"
                  >
                    <div className="dashboard__doughnut  relative  ">
                      <p className="dash-cat absolute">Genres</p>
                      <DoughnutChart
                        className="absolute"
                        data={categoryData}
                        options={getDoughnutChartOptions("Alaa")}
                      />
                    </div>
                    <div className="dashboard__doughnut-data wd-100  flex dir-col items-start ">
                      <div className="dashboard__doughnut-data-content ">
                        {categoryDataSet &&
                          categoryDataSet?.map((item, index) => {
                            return (
                              <div
                                className="dashboard__category-titles"
                                key={index}
                              >
                                <div
                                  className="dashboard__title-color"
                                  style={{
                                    backgroundColor:
                                      item?.color.length >= 7
                                        ? item?.color
                                        : "#000",
                                  }}
                                  // style={{ backgroundColor: "#5711e" }}
                                ></div>
                                <div className="dashboard__title-name">
                                  {item?.name}{" "}
                                  <span
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      color: "#333",
                                    }}
                                  >
                                    {`(${+categoryPercentage[index].toFixed(
                                      2
                                    )}%)`}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div className="dashboard__section  ">
              <div className="dashboard__hourly-views  ">
                <div className="dashboard__view-subHeader  ">
                  <SubHeader
                    bgColor="#31AA4A"
                    title="Views By Hours"
                    titleColor="#1A1D1F"
                    history="hourly-views"
                    handleHistory={getHourlyViewsDaysCount}
                    method="hours"
                  />
                </div>
                <div className="dashboard__view-chart  ">
                  {lineChartLoading && (
                    <div className="dashboard__chart-loading ">
                      <Spin />
                    </div>
                  )}
                  {!lineChartLoading && (
                    <LineChart
                      data={lineData}
                      options={getLineChartOptions("Hourly Views")}
                    />
                  )}
                </div>
              </div>
            </div>

            {/* <div className="dashboard__search-container">
              <Select
                dropdownStyle={dropdownStyle}
                className="search__searchField py-1 wd-100"
                defaultValue="Select Genre"
                value={selectedGenre || "Select Genre"}
                onSelect={(value) => {
                  setSelectedGenre(value);
                  setSelectedCategory("");
                  setSearchValue("");
                }}
              >
                {genres?.map((genre) => {
                  return (
                    <Select.Option key={genre.id} value={genre.id}>
                      {genre.name}
                    </Select.Option>
                  );
                })}
              </Select>
              <Select
                dropdownStyle={dropdownStyle}
                className="search__searchField py-1 wd-100"
                disabled={disableCategory}
                value={selectedCategory || "Select Category"}
                onSelect={(value) => setSelectedCategory(value)}
              >
                {categories?.map((category) => {
                  return (
                    <Select.Option key={category.id} value={category.id}>
                      {category.name}
                    </Select.Option>
                  );
                })}
              </Select>

              <Input
                type="text"
                className="search__searchField py-2"
                placeholder={"Search movie"}
                value={searchValue}
                onChange={handleSearchOnChange}
                prefix={
                  <button className="search__button">
                    <img src={magnifyingGlass} alt="search" />
                  </button>
                }
              />

              <Button
                style={{ opacity: resetButton || searchValue ? 1 : 0 }}
                type="danger"
                onClick={handleResetSearch}
                className="button"
              >
                Reset
              </Button>
            </div> */}

            <div className="dashboard__section  ">
              <div className="dashboard__hourly-views ">
                <div className="dashboard__trending   wd-100 ">
                  <div className="dashboard__view-subHeader  ">
                    <SubHeader
                      bgColor="gradient"
                      title="Trending Shows"
                      titleColor="#1A1D1F"
                      history="trending-shows"
                      handleHistory={getTrendingShowsDaysCount}
                      method="days"
                    />
                  </div>

                  <div className="dashboard__search-container">
                    <Select
                      dropdownStyle={dropdownStyle}
                      className="search__searchField py-1 wd-100"
                      defaultValue="Select Genre"
                      value={selectedGenre || "Select Genre"}
                      onSelect={(value) => {
                        setSelectedGenre(value);
                        setSelectedCategory("");
                        setSearchValue("");
                      }}
                    >
                      {genres?.map((genre) => {
                        return (
                          <Select.Option key={genre.id} value={genre.id}>
                            {genre.name}
                          </Select.Option>
                        );
                      })}
                    </Select>
                    <Select
                      dropdownStyle={dropdownStyle}
                      className="search__searchField py-1 wd-100"
                      disabled={disableCategory}
                      value={selectedCategory || "Select Category"}
                      onSelect={(value) => setSelectedCategory(value)}
                    >
                      {categories?.map((category) => {
                        return (
                          <Select.Option key={category.id} value={category.id}>
                            {category.name}
                          </Select.Option>
                        );
                      })}
                    </Select>

                    <Input
                      type="text"
                      className="search__searchField py-2"
                      placeholder={"Search movie"}
                      value={searchValue}
                      onChange={handleSearchOnChange}
                      prefix={
                        <button className="search__button">
                          <img src={magnifyingGlass} alt="search" />
                        </button>
                      }
                    />

                    <Button
                      style={{ opacity: resetButton || searchValue ? 1 : 0 }}
                      type="danger"
                      onClick={handleResetSearch}
                      className="button"
                    >
                      Reset
                    </Button>
                  </div>

                  <div className="dashboard__table  ">
                    <Table
                      rowKey={(row) => row?.videoId}
                      pagination={{
                        defaultPageSize: "7",
                        responsive: true,
                        hideOnSinglePage: true,
                        pageSizeOptions: ["7", "10", "20", "50", "100"],
                      }}
                      className="general-table"
                      columns={trendingShowsColumns}
                      dataSource={trendingShowsData}
                      rowClassName={(record, index) =>
                        index % 2 === 0 && "background-even-records "
                      }
                      scroll={{ x: true }}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Dashboard;
